export const getGroupNotifications = (list) => {
  const sorted = [...list].sort((a, b) => {
    const unitCmp = String(a.unit ?? "").localeCompare(String(b.unit ?? ""));
    if (unitCmp !== 0) return unitCmp;
    const eventCmp = String(a.event ?? "").localeCompare(String(b.event ?? ""));
    if (eventCmp !== 0) return eventCmp;
    return (Number(b.set) || 0) - (Number(a.set) || 0);
  });

  const groups = [];

  for (const notif of sorted) {
    const lastGroup = groups[groups.length - 1];

    if (
      lastGroup &&
      lastGroup.unit === notif.unit &&
      lastGroup.event === notif.event &&
      Boolean(lastGroup.active) === Boolean(notif.active) &&
      Boolean(lastGroup.acknowledged) === Boolean(notif.acknowledged) &&
      Boolean(lastGroup.closed) === Boolean(notif.closed)
    ) {
      lastGroup.items.push(notif);
    } else {
      const id = `${notif.unit}#${notif.event}#${notif.set}`;

      groups.push({
        id,
        unit: notif.unit,
        event: notif.event,
        message: notif.message,
        severity: notif.severity,
        set: notif.set,
        clear: notif.clear,
        duration: notif.duration,
        acknowledged: notif.acknowledged,
        acknowledged_by: notif.acknowledged_by,
        active: notif.active,
        closed: notif.closed,
        items: [notif],
      });
    }
  }

  return groups.sort((a, b) => {
    return (Number(b.set) || 0) - (Number(a.set) || 0);
  });
};
